import O1HD from "../../../engines/gameEngine";
import utilsView from "../../../engines/libs/utilsView";
import { MessageEventKind } from "../../../modes/define/MessageEventKind";
import { TaskKind } from "../../../modes/define/TaskKind";
import { backPackEventMap } from "../../../modes/normalMode/config/BackpackEventConfig";
import NormalGameManager from "../../../modes/normalMode/manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CupidHelp3Layer extends cc.Component {

    @property(cc.Node)
    nodeClose: cc.Node = null;

    @property({type:cc.Node,tooltip:"对话节点"})
    chatNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"丘比特节点"})
    cupidNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"按钮layout1"})
    btnLayout1:cc.Node = null;
    @property({type:cc.Node,tooltip:"按钮layout2"})
    btnLayout2:cc.Node = null;
    @property({type:cc.Node,tooltip:"按钮layout3"})
    btnLayout3:cc.Node = null;

    @property({type:cc.SpriteFrame})
    cupidSps:cc.SpriteFrame[] = [];

    readonly chats:string[] = [
        "你来啦，是帮我找回翅膀了吗",
        "谢谢你，快把翅膀给我吧",
        "这是什么情况呀",
        "#@！#@~#@$%^^%^^%^#!YY$!$^^@#!@%",
        "还是谢谢你帮我找回翅膀，我就先走啦！"
    ]

    curIndex:number = 0;

    start(){
        O1HD.getModules().uiControlModule.hideLoading();
        this.chatNode.scale = 0;
        this.chatNode.active = true;
        this.btnLayout1.active = false;
        this.btnLayout2.active = false;
        this.btnLayout3.active = false;
        this.oneStep();
    }

    oneStep(){
        this.btnLayout1.active = true;
        this.showOneChat(this.chats[0],0);
    }

    twoStep(){
        this.btnLayout2.active = true;
        this.showOneChat(this.chats[1],0);
    }

    threeStep(){
        this.chatNode.scale = 0;
        cc.tween(this.cupidNode).to(0.5,{opacity:0}).call(()=>{
            this.cupidNode.getComponent(cc.Sprite).spriteFrame = this.cupidSps[0];
        }).delay(0.2).to(0.2,{opacity:255}).call(()=>{
            this.showOneChat(this.chats[2],1);
        }).delay(2).call(()=>{
            this.fourStep();
        }).start();
    }

    fourStep(){
        this.showOneChat(this.chats[3],1);        
        cc.tween(this.cupidNode).delay(2).to(0.5,{opacity:0}).call(()=>{
            this.cupidNode.getComponent(cc.Sprite).spriteFrame = this.cupidSps[1];
        }).delay(0.2).to(0.2,{opacity:255}).call(()=>{
            this.chatNode.scale = 0;
        }).delay(1).call(()=>{
            this.fiveStep();
        }).start();
        
    }

    fiveStep(){
        this.btnLayout3.active = true;
        this.showOneChat(this.chats[4],1);
        this.cupidNode.getComponent(cc.Sprite).spriteFrame = this.cupidSps[1];
    }

    async showOneChat(chat:string,type:number){
        cc.Tween.stopAllByTarget(this.chatNode);
        this.chatNode.scale = 0;
        let lbChat:cc.Label = this.chatNode.getChildByName("label").getComponent(cc.Label);
        lbChat.string = chat;
        switch(type){
            case 0:{
                this.chatNode.y = 0;
                break;
            }
            case 1:{
                this.chatNode.y = 250;
                break;
            }
        }
        cc.tween(this.chatNode).to(0.2,{scale:1},{easing:cc.easing.backOut}).start();
    }

    onBtnYes(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.btnLayout1.active = false;
        this.twoStep();
    }

    onBtnNo(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    onBtnDelivery(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let backItem = NormalGameManager._instance.getOneGood(50020);
        if(!backItem || backItem.num <= 0){
            O1HD.getModules().uiControlModule.showMessageBox("暂未找回翅膀");
            return;
        }
        NormalGameManager._instance.onOutGoods(50020,1);
        this.nodeClose.active = false;
        NormalGameManager._instance.taskDataManage.addNewFinishTask(TaskKind.TaskId.TASK_7);
        this.btnLayout2.active = false;
        this.threeStep();
    }

    async onBtnComit(){
        this.nodeClose.active = true;
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let addGoodsList = {};
        addGoodsList[50013] = 1;
        await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
        NormalGameManager._instance.onPushGoods(50013,1);
        NormalGameManager._instance.setGameData({isDeliveryWings:true});
        O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }
    
    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

}
